/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do .aside
 */

export default styled.aside`
  background-color: white;
  color: #5e6366;
  height: 100%;
  width: 256px;
  float: left;
  position: relative;
  display: ${({ isHided }) => (isHided ? 'none' : 'inherit')};

  @media (max-width: 768px) {
    position: fixed;
    z-index: 1200;
    width: 0;
    top: 42px;
  }

  .add-layer-button {
    width: 18px;
    height: 18px;
    vertical-align: bottom;
    margin-left: 12px;
    &:hover {
      color: #3c71dd;
    }
  }

  div.content {
    background-color: white;
    color: #5e6366;
    height: calc(100% ${({ toolBar }) => (toolBar ? '' : ' - 42px')});
    top: ${({ toolBar }) => (toolBar ? '0' : ' 42px')};
    width: 100%;
    float: left;
    position: absolute;
    transition: 0.5s all;

    @media (max-width: 768px) {
      background-color: transparent;
      height: auto;
      width: 226px;
      left: ${({ isOpened }) => (isOpened ? 0 : '-226px')};
      border-radius: 0px 3px 3px 0px;
      top: calc(58px - 42px);

      header {
        display: flex;
        position: absolute;
        height: 58px;
        width: 100%;
        box-sizing: border-box;
        top: -58px;
        padding: 20px 16px;
        background: white;
        color: #000;
        border-bottom: 0.5px solid rgba(31, 45, 77, 0.5);

        svg {
          margin-right: 10px;

          path {
            fill: black;
          }
        }

        h1 {
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }

  header {
    display: none;
  }

  nav {
    @media (min-width: 768px) {
      background: ${({ toolBar, theme }) =>
        toolBar ? 'none' : theme.primaryColorDark};
      width: ${({ toolBar }) => (toolBar ? 'auto' : '100%')};
      top: ${({ toolBar }) => (toolBar ? '-42px' : '0')};
    }
    position: absolute;
    height: 42px;
    top: -42px;
    left: 0;
    white-space: nowrap;

    ul {
      display: flex;
      margin: 0;
      padding: 0;
      height: 100%;

      li {
        display: inline;
        height: 100%;
        z-index: 1700;
      }
    }
  }
`;

/**
 * Estilização do .layers-container
 */

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  height: 30px;
  padding: 20px 10px;
  border-bottom: 2px solid #e0e0e0 !important;
  padding: 0 16px;
  cursor: ${({ active }) => (active ? 'pointer' : 'not-allowed')};
`;
